// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__26PNg","col":"styles_col__1uL9L"};